import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router'
import { TitlePage } from 'components/atoms'
import { CardLoader } from 'components/organisms'
import { CmsHomepageSectionEditForm } from 'domains/cms-homepage-section/organisms'
import CmsHomepageSectionApiV2 from 'api/v2/admins/cms-homepage-sections-api-v2'
import CmsHomepageSectionService from 'domains/cms-homepage-section/services/cms-homepage-section-service'
import { ALERT_TYPES } from 'constants/alert-constants'
import withLoader from 'hocs/with-loader'
import PropTypes from 'prop-types'
import { Button } from 'reactstrap'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const defaultProps = {
  pageUtils: {
    setAlertMsg    : () => {},
    setApiErrorMsg : () => {}
  }
}

const CmsHomepageSectionEditPage = ({ pageUtils }) => {

  const { id }                      = useParams()
  const [ section, setSection ]     = useState({})
  const [ isLoading, setIsLoading ] = useState(true)
  const history                     = useHistory()

  useEffect(() => {
    CmsHomepageSectionApiV2.show(id)
      .then((response) => {
        const section = response.data.section
        setSection(section)
        setIsLoading(false)
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data))
  }, [ id, pageUtils ])

  const handleSubmitForm = async (values) => {

    const landscapeImage     = CmsHomepageSectionService.prepImage(values.landscape_image)
    const portraitImage      = CmsHomepageSectionService.prepImage(values.portrait_image)
    const captionTextPayload = CmsHomepageSectionService.prepText(values.caption_text)
    const headerTextPayload  = CmsHomepageSectionService.prepText(values.header_text)
    const titleTextPayload   = CmsHomepageSectionService.prepText(values.title_text)

    const params = {
      'is_active'       : values.is_active,
      'name'            : values.name,
      'landscape_image' : landscapeImage,
      'portrait_image'  : portraitImage,
      'url'             : values.url,
      'alt_text'        : values.alt_text,
      'caption_text'    : captionTextPayload,
      'header_text'     : headerTextPayload,
      'button_text'     : values.button_text,
      'order'           : values.order,
      'seo_title'       : values.seo_title,
      'platform'        : values.platform,
      'title_text'      : titleTextPayload
    }

    const payload = CmsHomepageSectionService.toFormData(params)

    await CmsHomepageSectionApiV2.putSection(
      id,
      payload
    )
      .then(() => {
        pageUtils.setAlertMsg('Sucessfully update homepage section!', ALERT_TYPES.SUCCESS)
      })
      .catch((error) => {
        pageUtils.setApiErrorMsg(error.response.data)
      })
  }

  const handleClickBack = () => {
    history.goBack()
  }

  const CmsHomepageSectionEditFormWithLoader = withLoader(CmsHomepageSectionEditForm, CardLoader )

  return (
    <>
      <Button
        outline
        color='default'
        size='sm'
        className='mb-2'
        onClick={ handleClickBack }
      >
        <i className='fas fa-chevron-left mr-2' />
        <span>Back</span>
      </Button>
      <TitlePage mainTitle='Edit CMS Homepage Section' />
      <CmsHomepageSectionEditFormWithLoader
        isLoading={ isLoading }
        section={ section }
        handleSubmitForm={ handleSubmitForm }
      />
    </>
  )
}

CmsHomepageSectionEditPage.propTypes    = propTypes
CmsHomepageSectionEditPage.defaultProps = defaultProps

export default CmsHomepageSectionEditPage
